"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.levelStyles = exports.getStylesByLevel = exports.getStyleVariables = exports.getLevelFromVariant = exports.getKindFromColor = void 0;
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var levelStyles = exports.levelStyles = {
  heroLarge: "\n    font-size: ".concat(_js["default"].alias.typography.heroLarge.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.heroLarge.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.heroLarge.lineHeight, ";\n    letter-spacing: ").concat(_js["default"].alias.typography.heroLarge.letterSpacing, ";\n  "),
  heroMedium: "\n    font-size: ".concat(_js["default"].alias.typography.heroMedium.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.heroMedium.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.heroMedium.lineHeight, ";\n    letter-spacing: ").concat(_js["default"].alias.typography.heroMedium.letterSpacing, ";\n  "),
  heroSmall: "\n    font-size: ".concat(_js["default"].alias.typography.heroSmall.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.heroSmall.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.heroSmall.lineHeight, ";\n    letter-spacing: ").concat(_js["default"].alias.typography.heroSmall.letterSpacing, ";\n  "),
  display: "\n    font-size: ".concat(_js["default"].alias.typography.display.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.display.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.display.lineHeight, ";\n    letter-spacing: ").concat(_js["default"].alias.typography.display.letterSpacing, ";\n  "),
  heading: "\n    font-size: ".concat(_js["default"].alias.typography.heading.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.heading.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.heading.lineHeight, ";\n    letter-spacing: ").concat(_js["default"].alias.typography.heading.letterSpacing, ";\n  "),
  title: "\n    font-size: ".concat(_js["default"].alias.typography.title.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.title.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.title.lineHeight, ";\n    letter-spacing: ").concat(_js["default"].alias.typography.title.letterSpacing, ";\n  "),
  bodyStrong: "\n    font-size: ".concat(_js["default"].alias.typography.bodyStrong.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.bodyStrong.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.bodyStrong.lineHeight, ";\n  "),
  body: "\n    font-size: ".concat(_js["default"].alias.typography.body.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.body.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.body.lineHeight, ";\n  "),
  captionStrong: "\n    font-size: ".concat(_js["default"].alias.typography.captionStrong.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.captionStrong.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.captionStrong.lineHeight, ";\n  "),
  caption: "\n    font-size: ".concat(_js["default"].alias.typography.caption.fontSize, ";\n    font-weight: ").concat(_js["default"].alias.typography.caption.fontWeight, ";\n    line-height: ").concat(_js["default"].alias.typography.caption.lineHeight, ";\n  ")
};
var getKindFromColor = exports.getKindFromColor = function getKindFromColor(color) {
  var colorToKindMap = {
    primary: 'interaction',
    secondary: 'highlight',
    "default": 'default',
    textPrimary: 'default',
    textSecondary: 'lighter',
    success: 'positive',
    error: 'critical',
    disabled: 'disabled'
  };
  return colorToKindMap[color || ''] || 'default';
};
var getLevelFromVariant = exports.getLevelFromVariant = function getLevelFromVariant(variant) {
  var variantToLevelMap = {
    display1: 'heroSmall',
    headline: 'heading',
    subheading: 'body',
    label: 'caption',
    caption: 'caption',
    button: 'body',
    title: 'title',
    title1: 'heroSmall',
    title2: 'display',
    title3: 'heading',
    title4: 'title',
    body: 'body',
    body1: 'body',
    body2: 'bodyStrong'
  };
  return variantToLevelMap[variant] || 'default';
};
var getSpacingValue = function getSpacingValue(param) {
  return typeof param === 'number' ? "".concat(param * 8, "px") : param;
};
var getStylesByLevel = exports.getStylesByLevel = function getStylesByLevel(level) {
  return levelStyles[level];
};
var getFontConfigByBreakpoint = function getFontConfigByBreakpoint(level, device) {
  var _ref;
  return level && level[device] ? (_ref = {}, _defineProperty(_ref, "--font-size-".concat(device), _js["default"].alias.typography[level[device]].fontSize), _defineProperty(_ref, "--font-weight-".concat(device), _js["default"].alias.typography[level[device]].fontWeight), _defineProperty(_ref, "--line-height-".concat(device), _js["default"].alias.typography[level[device]].lineHeight), _defineProperty(_ref, "--letter-spacing-".concat(device), _js["default"].alias.typography[level[device]].letterSpacing || ''), _ref) : {};
};
var getStyleVariables = exports.getStyleVariables = function getStyleVariables(align, level, legacySpacingProps) {
  var m = legacySpacingProps.m,
    mt = legacySpacingProps.mt,
    mr = legacySpacingProps.mr,
    mb = legacySpacingProps.mb,
    ml = legacySpacingProps.ml,
    mx = legacySpacingProps.mx,
    my = legacySpacingProps.my,
    p = legacySpacingProps.p,
    pt = legacySpacingProps.pt,
    pr = legacySpacingProps.pr,
    pb = legacySpacingProps.pb,
    pl = legacySpacingProps.pl,
    px = legacySpacingProps.px,
    py = legacySpacingProps.py;
  return _objectSpread(_objectSpread({
    '--align': align
  }, _typeof(level) === 'object' ? _objectSpread(_objectSpread(_objectSpread({}, getFontConfigByBreakpoint(level, 'mobile')), getFontConfigByBreakpoint(level, 'tablet')), getFontConfigByBreakpoint(level, 'desktop')) : {}), {}, {
    '--m': getSpacingValue(m),
    '--mt': getSpacingValue(mt),
    '--mr': getSpacingValue(mr),
    '--mb': getSpacingValue(mb),
    '--ml': getSpacingValue(ml),
    '--mx': getSpacingValue(mx),
    '--my': getSpacingValue(my),
    '--p': getSpacingValue(p),
    '--pt': getSpacingValue(pt),
    '--pr': getSpacingValue(pr),
    '--pb': getSpacingValue(pb),
    '--pl': getSpacingValue(pl),
    '--px': getSpacingValue(px),
    '--py': getSpacingValue(py)
  });
};